// GERENTE
export { Producciones } from "./Gerente/pages/Producciones";
export { CreacionProduccion } from "./Gerente/pages/CreacionProduccion";
export { EdicionProduccion } from "./Gerente/pages/EdicionProduccion";

// TURNOS PRODUCCIÓN
export { TurnosProduccion } from "./Supervisor/pages/TurnosProduccion";

// TANCADAS
export { Tancadas } from "./Supervisor/pages/Tancadas/Tancadas";
export { CargasTancada } from "./Supervisor/pages/Tancadas/CargasTancada";
export { TancadasTurno } from "./Supervisor/pages/Tancadas/TancadasTurno";

// PRODUCCIÓN REPORTADA
export { ProduccionReportada } from "./Supervisor/pages/ProduccionReportada";

// PALETIZACIÓN
export { Paletizaciones } from "./Supervisor/pages/Paletizacion/Paletizaciones";
export { CreacionPaletizacion } from "./Supervisor/pages/Paletizacion/CreacionPaletizacion";
export { DetallePaletizacion } from "./Supervisor/pages/Paletizacion/DetallePaletizacion";

// CIERRE DE TURNO
export { CierreTurno } from "./Supervisor/pages/CierreTurno";

// DETALLE TURNO FINALIZADO
export { DetalleTurnoFinalizado } from "./Supervisor/pages/DetalleTurnoFinalizado";

// MIGA DE DESECHO
export { MigaDesecho } from "./Supervisor/pages/MigaDesecho";

// BULTOS SKIM
export { BultosSkim } from "./Supervisor/pages/BultosSkim";

// CIERRES MENSUALES
export { CierresMensualesProduccion } from "./CierresMensuales/pages/CierresMensualesProduccion";
export { RegistroCierreMensualProduccion } from "./CierresMensuales/pages/RegistroCierreMensualProduccion";
export { DetalleCierreMensualProduccion } from "./CierresMensuales/pages/DetalleCierreMensualProduccion";

// REPORTES
export { ReportesProduccion } from "./Reportes/pages/ReportesProduccion";
